import { ResourcesItem } from 'redux-and-the-rest';

import { EDUCATOR_USER, GUEST_USER, RoleModel } from '../models/roleModel';
import { UserModel } from '../models/userModel';

function isRegisteredUser(user: ResourcesItem<UserModel>): boolean {
  if (!user.values) {
    return false;
  }

  if (Object.keys(user.values).length === 0) {
    return false;
  }

  return !user.values.roles
    .map(({ id }: RoleModel) => id)
    .includes(GUEST_USER);
}

function isEducator(user: ResourcesItem<UserModel>): boolean {
  return user?.values?.roles?.map(({ id }: RoleModel) => id)
    .includes(EDUCATOR_USER);
}

export {
  isRegisteredUser,
  isEducator,
};
